const MarchingBlocks = ({ style = {}, width = 192, ...props }) => (
  <img {...props} width={width} src="/loading.svg" style={style} />
);

export default MarchingBlocks;
